import React, {useState} from 'react';
import { Image, Button, Header } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';


/**
 * status: {success, failed}
 */
const PaymentMessage = props => {
  const { t } = useTranslation();
  const { status } = props;
  const history = useHistory();
  const [isDisabled, setIsDisabled] = useState(false)

  const text = {
    success: {
      title: t('paymentSuccessTitle'),
      message: t('paymentSuccessMessage'),
    },
    failed: {
      title: t('paymentFailTitle'),
      message: t('paymentFailMessage'),
    },
    details: t('transactionDetails'),
    back: t('goBack'),
  };

  const cssClass = `paymentMessage  ${status}`;

  const handleBackBtn = () => {
    setIsDisabled(true);
    if (isMobile) {
      window.location = 'vibino://subscriptionDone';
      setTimeout(() => {
        history.push('/home');
      }, 2000);
    }else{
      history.push('/home');
    }
  }

  return (
    <div className={cssClass}>
      <Image className="messageIcon" src={require(`../../assets/images/${status}Icon.svg`)} />
      <Header className="title success textCenter" as="h1">
        {text[status].title}
      </Header>
      <div className="detailsBox">
        <span className="message textCenter">{text[status].message} </span>
        {false && (
          <div className="transactionDetail">
            <div className="boxHeader">{text.details}</div>
            <div className="boxContent"></div>
          </div>
        )}
      </div>
      <div className="footer">
        <Button
          className="vButton outlinePrimary paymentBackBtn"
          content={text.back}
          onClick={() => handleBackBtn()}
          disabled = {isDisabled}
        />
      </div>
    </div>
  );
};

PaymentMessage.propTypes = {
  status: PropTypes.string,
};

export default PaymentMessage;
